"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Noteefied = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class Noteefied {
    constructor() { }
    /**********************************************************************************************************************
     *                     START : NOTEEFIED Software Parser
     * ********************************************************************************************************************/
    /**
     * @function parse
     * @param pastedData
     * @param event
     * @param callbackEmit
     * @summary NoteefiedSoftwareParser Software Parser @pastedData string break by session to session
     * @returns {callback}
     */
    parse(pastedData, event, callbackEmit) {
        try {
            //**Session 1 Patient name*/
            const sessionFirst = (0, helper_1.substrInBetween)(pastedData, "Last Name:", "Race / Ethnicity:");
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(sessionFirst);
            //**Session 3 Insurance*/
            const sessionThird = pastedData.substring(pastedData.indexOf("INSURANCE INFORMATION") + 21);
            const insurance = this.getInsurance(sessionThird);
            //**Session 6 Emergency Contact*/
            const sessionSix = (0, helper_1.substrInBetween)(pastedData, "Categories:", "SPECIAL INSTRUCTIONS");
            //**Session 7 Primary Physician*/
            const sessionSeven = (0, helper_1.substrInBetween)(pastedData, "PHYSICIANS", "UPIN:");
            //**Session 8 Pharmacy*/
            const sessionEight = (0, helper_1.substrInBetween)(pastedData, "N/A:", "N/A");
            const physicianInfo = this.getPrimaryPhysician(sessionSix, sessionSeven, sessionEight);
            //**Session 9 Comments*/
            const sessionNine = (0, helper_1.substrInBetween)(pastedData, "N/A", "N/A");
            const comment = this.getComment(sessionNine);
            const sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), physicianInfo), insurance), comment);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Noteefied
     */
    gettingPatientDetails(sessionFirst) {
        if (!sessionFirst) {
            return {};
        }
        let dob = (0, helper_1.substrInBetween)(sessionFirst, "Birth Date:", "Age:");
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst.substr(0, sessionFirst.indexOf("Suffix:")))), this.patientPhoneNumberWithAddress(sessionFirst)), { email: (0, helper_1.getEmailAddress)((0, helper_1.substrInBetween)(sessionFirst, "Email Address:", "Medicare Number:")), dob: (0, helper_1.getDOB)(dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Noteefied
     */
    getInsurance(sessionThird) {
        sessionThird = (0, helper_1.substrInBetween)(sessionThird, "Primary:", "Other:");
        if (!sessionThird) {
            return {};
        }
        const insurance = sessionThird.split("#:");
        //Primary Insurance and Secondary Insurance
        return { insurance: (0, helper_1.trim)(insurance[0]) };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Noteefied
     */
    getPrimaryPhysician(sessionSix, sessionSeven, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
                careGiver: this.getCaregiver(sessionSix),
            },
        };
        const phyName = (0, helper_1.substrInBetween)(sessionSeven, "Prescribing:", "Referring:");
        primaryPhy.info.physician[0].name = (0, helper_1.trim)(phyName);
        //Get Numbers
        const numbers = (0, helper_1.phoneNumbers)((0, helper_1.substrInBetween)(sessionSeven, "Phone:", "NPI:"));
        if (primaryPhy.info.physician[0].name && numbers) {
            const firstNumber = numbers[0].replace(/[\s-()]/g, "");
            primaryPhy.info.physician[0].phoneNo = (0, helper_1.changeNumberUSFormat)(firstNumber);
        }
        //@Return
        return primaryPhy;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        data = (0, helper_1.trim)(data);
        //Return black data
        if (!data) {
            return pharmacyData;
        }
        //convert to array
        //@Return
        return pharmacyData;
    }
    getCaregiver(data) {
        const caregiverData = [
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            },
            {
                name: "",
                phoneNo: "",
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 2,
            },
        ];
        //Blank data Return
        if (!data) {
            return caregiverData;
        }
        data = data.trim();
        const dataToArray = data.split("PATIENT CONTACT PERSON");
        if (!(0, helper_1.arrayLength)(dataToArray)) {
            return caregiverData;
        }
        //Loop
        for (const value of dataToArray) {
            if (value.indexOf("Relationship") != -1) {
                const relationship = (0, helper_1.substrInBetween)(value, "Relationship:", "Name:");
                let name = (0, helper_1.substrInBetween)(value, "Name:", "Home Phone:");
                const numbers = (0, helper_1.phoneNumbers)(value);
                let number = null;
                if (numbers && (0, helper_1.arrayLength)(numbers)) {
                    const firstNumber = numbers[0].replace(/[\s-()]/g, "");
                    number = (0, helper_1.changeNumberUSFormat)(firstNumber);
                }
                //Continue
                if (!name || !number) {
                    continue;
                }
                //Add relationship
                if (name && relationship) {
                    name += ` (${relationship})`;
                }
                if (!caregiverData[0].name) {
                    caregiverData[0].name = (0, helper_1.trim)(name);
                    caregiverData[0].phoneNo = number;
                }
                else {
                    caregiverData[1].name = (0, helper_1.trim)(name);
                    caregiverData[1].phoneNo = number;
                    //Loop Break;
                    break;
                }
            }
        }
        //@Return
        return caregiverData;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        //Numbers
        const numbers = (0, helper_1.phoneNumbers)((0, helper_1.substrInBetween)(firstSession, "Home Phone:", "Fax No."));
        //Set Last number
        if (numbers && numbers.length) {
            const lastNumber = numbers[numbers.length - 1];
            info.phoneNo = lastNumber.replace(/[\s-()]/g, "");
        }
        //set address
        info.address.placeName = (0, helper_1.substrInBetween)(firstSession, "Address:", "Home Phone:");
        //@Return address or phoneNo
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        const name = {
            firstName: "",
            lastName: "",
        };
        //Value trim
        if (sessionFirst) {
            sessionFirst = (0, helper_1.trim)(sessionFirst);
        }
        const lastName = sessionFirst.substr(0, sessionFirst.indexOf("First Name:"));
        const midName = sessionFirst.substring(sessionFirst.indexOf("Middle Initial:") + 15);
        const firstName = (0, helper_1.substrInBetween)(sessionFirst, "First Name:", "Middle Initial:");
        name.firstName = (0, helper_1.trim)(firstName);
        name.lastName = `${(0, helper_1.trim)(midName)} ${(0, helper_1.trim)(lastName)}`;
        //@Return name
        return name;
    }
    /**
     * @function getComment
     * @param comment
     * @summary Getting Comment filed from Noteefied
     */
    getComment(comment) {
        if (comment) {
            return { about: comment };
        }
        return { about: "" };
    }
}
exports.Noteefied = Noteefied;
